<div class="select-container" [id]="uniqueId">
    <button class="custom-select" [ngClass]="{'open-dropdown': openDropdown, 'error': error}"
        (click)="toggleDropdown()">
        <div class="span-ellipsis" *ngIf="selectedObject !== null && selectedObject !== undefined">
            <span *ngIf="translateKey && (selectedObject !== null && selectedObject !== undefined)">
                {{ translateKey + selectedItem[keyName[0]] | translate
                }}
            </span>
            <span *ngIf="!translateKey && (selectedObject !== null && selectedObject !== undefined)">
                <div>
                    {{ selectedItem ? selectedItem[keyName[0]] : '' }}
                </div>

            </span>
        </div>
        <div class="span-ellipsis" *ngIf="(selectedObject === null || selectedObject === undefined) && loading">
            <span class="placeholder-select ">
                {{'loading' | translate}}
            </span>
        </div>
        <div class="span-ellipsis" *ngIf="(selectedObject === null || selectedObject === undefined) && !loading">
            <span class="placeholder-select">
                {{ placeholder }}
            </span>
        </div>

        <div class="chevron" [class.open]="openDropdown"></div>
    </button>
    <div class="options-container" [ngClass]="{'absolute': showAbsolute}" *ngIf="openDropdown">
        <div class="options-scroll">
            <div *ngFor="let option of dataArray; let last = last">
                <button (click)="selectOption(option)" class="option" [class.selected-option]="isSelected(option)"
                    [attr.aria-selected]="isSelected(option)">

                    <div>
                        <p *ngFor="let key of keyName"> {{ translateKey ? (translateKey + option[key] | translate) :
                            option ?
                            option[key] : ''}} </p>
                    </div>

                    <img *ngIf="isSelected(option)" src="../../../../../../../../assets/icons/solid_check.webp"
                        alt="Check Icon" loading="lazy">
                </button>
                <div class="split-option" *ngIf="!last"></div>
            </div>
        </div>
    </div>
</div>